/**
 * Фильтрует массив
 */

const getSearchedData = (data: any[], fields: string[], search: string) => {
  if (!search && !data) {
    return null;
  }

  const escapedSearch = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  return data.filter(item => {
    const searchStr = fields.map(field => item[field]).join(' ');

    const regExp = new RegExp(escapedSearch, 'i');

    return regExp.test(searchStr);
  });
};

export default getSearchedData;
